<template>
  <div :class="$style.gift" ref="gift">
    <div :class="$style.tabs" v-if="normal_gift.length || game_gift.length">
      <span :class="[activeTab == 1 ? $style.active : '']" @click="selectActiveTab(1)" v-if="normal_gift.length">平台专属礼包</span>
      <span :class="[activeTab == 2 ? $style.active : '']" @click="selectActiveTab(2)" v-if="game_gift.length">游戏礼包</span>
    </div>
    <ul v-if="giftList.length && activeTab == 1">
      <li v-for="(item, index) in giftList" :key="index" :style="getBackground(index)" @click="showGift(item)">
        <div :class="$style.info">
          <p>{{ item.title }}</p>
          <p :class="$style.detail">{{ item.description }}</p>
          <p v-if="item.expire_time">有效期 至 {{ item.expire_time }}</p>
          <p v-if="item.list_type === 2">{{ item.eg }}</p>
        </div>
        <div v-if="item.list_type === 2" :class="$style.btn">
          <img v-if="item.list_type === 2" :src="`${$cdnLink}/common/xinagyou.svg`" alt="" :class="$style.btn" />
        </div>
      </li>
    </ul>
    <ul v-if="giftList.length && activeTab == 2">
      <li v-for="(item, index) in giftList" :key="index" :style="getBackground2(index)" :class="[item.conditionShow ? $style.showDesc : '']">
        <div :class="$style.info">
          <p>{{ item.title }}</p>
          <p :class="$style.detail">{{ item.description }}</p>
          <p v-if="item.expire_time">有效期 至 {{ item.expire_time }}</p>
        </div>
        <div :class="$style.oper">
          <p :class="[$style.btn, $style.a]" v-if="item.status == 3" @click="showGift(item)">查看</p>
          <p :class="[$style.btn, $style.b]" v-if="item.status == 1" @click="showGift(item, 1)">领取</p>
          <p :class="[$style.btn, $style.c]" v-if="item.status == -2" @click="$toast('请满足条件后再来领取吧')">未满足</p>
          <p :class="[$style.btn, $style.d]" v-if="item.status == -1" @click="showReason(item)">无法领取</p>
          <p :class="$style.condition" @click="item.conditionShow = !item.conditionShow">
            <span>领取条件</span>
            <img :src="item.conditionShow ? `${$cdnLink}/suspend/fuli/6_6.png` : `${$cdnLink}/suspend/fuli/6_5.png`" alt="" />
          </p>
        </div>
        <div :class="$style.desc" v-if="item.conditionShow">
          {{ getDesc(item) }}
        </div>
      </li>
    </ul>
    <!-- 运营后台游戏管理配置盒子包 或者 悬浮窗跳转类型为盒子 -->
    <div v-if="(boxStatus != 0 || jump_mode == 3) && normal_gift.length && activeTab == 1" @click="showMore" :class="$style.showMore">
      打开盒子app领取更多礼包
    </div>
    <!-- 跳转类型为公众号 -->
    <div :class="$style.getMore" @click="popupVisible = true" v-if="normal_gift.length && jump_mode == 1 && activeTab == 1">
      <span>领取更多</span>
      <img :src="`${$cdnLink}/suspend/qingbao/xiangyou.png`" alt="" />
    </div>
    <div v-if="!normal_gift.length && activeTab == 1" :class="$style.empty">
      <img :src="`${$cdnLink}/suspend/fuli/gitEmpty.png`" alt="" />
      <p v-if="boxStatus != 0">快去打开盒子领取吧</p>
      <div v-else>
        <p>
          快去<span>【{{ officalAccount }}】</span>领取吧
        </p>
        <p>公众号账号：{{ officalId }}</p>
      </div>
      <button class="btn" @click="openBox" v-if="boxStatus != 0">一键打开盒子领取</button>
      <button class="btn" :data-clipboard-text="officalId" @click="buryReport" v-else>一键复制打开微信领取</button>
    </div>
    <Popup v-if="popupVisible" type="gift" :account="officalAccount" :accountId="officalId" text="礼包领不停" @close="popupVisible = false"></Popup>
    <BoxDownLoad v-if="boxDownLoadShow" @close="boxDownLoadShow = false" :type="boxType"></BoxDownLoad>
  </div>
</template>

<script>
import Popup from '../common/Popup.vue';
import { mapState } from 'vuex';
import { boxDownloadUrl, wxBoxDownloadUrl, boxGiftUrl, wxBoxGiftUrl } from '@/config';
import Clipboard from 'clipboard';
import { giftReceiveApi } from '@/api/suspend';
import { buryReport } from '@/libs/business/account';
import { gameOpenDownloads, downloadProgress2H5, moreGift2sdk, skipWXBox2Sdk } from '@/bridge/AppJsBridge';
import { generJumpLink } from '@/libs/business/box';
import BoxDownLoad from '../common/boxDownload.vue';
import { buryReportV2 } from '@/libs/business/account';

export default {
  name: '',
  data() {
    return {
      popupVisible: false,
      gameType: '',
      boxStatus: '',
      boxType: 'bt',
      boxDownLoadShow: false,
      activeTab: 1, // 1.平台专属礼包 2.游戏礼包
      giftList: [],
    };
  },
  mounted() {
    this.copyInit();
    this.gameType = this.$getStorage('game_type');
    this.boxStatus = this.$getStorage('box_status');
    this.boxType = this.boxStatus == '1' ? 'bt' : 'wx';
    if (this.gameType === 'boxGame' || this.gameType === 'wxBoxGame') {
      downloadProgress2H5((data) => {
        this.$toast({
          message: data,
          position: 'bottom',
        });
      });
    }
    this.giftListInit();
  },
  computed: {
    ...mapState({
      officalAccount: (state) => state.suspend.account_name,
      officalId: (state) => state.suspend.account_id,
      jump_mode: (state) => state.suspend.jump_mode,
      normal_gift: (state) => state.suspend.normal_gift || [],
      game_gift: (state) => state.suspend.game_gift || [],
      role: (state) => state.suspend.role,
    }),
  },
  components: {
    Popup,
    BoxDownLoad,
  },
  methods: {
    selectActiveTab(type) {
      if (type == 1) {
        this.activeTab = 1;
        this.giftList = this.normal_gift;
        buryReportV2('SDK_AUTO_PLATFORM_GIFT', '');
      } else {
        this.activeTab = 2;
        this.giftList = this.game_gift.map((item) => {
          return {
            ...item,
            conditionShow: false,
          };
        });
        buryReportV2('SDK_AUTO_GAME_GIFT', '');
      }
    },
    giftListInit() {
      if (this.normal_gift.length) {
        this.activeTab = 1;
        this.giftList = this.normal_gift;
      } else if (!this.normal_gift.length && this.game_gift.length) {
        this.activeTab = 2;
        this.giftList = this.game_gift.map((item) => {
          return {
            ...item,
            conditionShow: false,
          };
        });
      }
    },
    showReason(item) {
      this.$toast(`创角天数已超过${item.over_limit_day}天，无法领取`);
    },
    buryReport() {
      buryReport('GIFT_CLICK_COPY');
    },
    copyInit() {
      this.clipboard = new Clipboard('.btn');
      this.clipboard.on('success', () => {
        this.$toast('复制成功');
        gameOpenDownloads({
          gameUrl: 'weixin://',
        });
      });
    },
    getBackground2(type) {
      if ([0, 4, 8].includes(type % 10)) {
        return `background-image: url('${this.$cdnLink}/suspend/fuli/bg1.png')`;
      } else if ([1, 5, 9].includes(type % 10)) {
        return `background-image: url('${this.$cdnLink}/suspend/fuli/bg2.png')`;
      } else if ([2, 6].includes(type % 10)) {
        return `background-image: url('${this.$cdnLink}/suspend/fuli/bg3.png')`;
      } else if ([3, 7].includes(type % 10)) {
        return `background-image: url('${this.$cdnLink}/suspend/fuli/bg4.png')`;
      }
    },
    getBackground(type) {
      switch (type) {
        case 0:
          return `background-image: url('${this.$cdnLink}/suspend/fuli/gift1.png')`;
        case 1:
          return `background-image: url('${this.$cdnLink}/suspend/fuli/gift2.png')`;
        case 2:
          return `background-image: url('${this.$cdnLink}/suspend/fuli/gift3.png')`;
        default:
          return `background-image: url('${this.$cdnLink}/suspend/fuli/gift4.png')`;
      }
    },
    getDesc(item) {
      if (item.condition_type == 1) {
        return item.role_limit_day
          ? `领取条件说明：创角${item.role_limit_day}日内，vip等级达到${item.condition_threshold}级`
          : `领取条件说明：vip等级达到${item.condition_threshold}级`;
      } else if (item.condition_type == 2 || item.condition_type == 5) {
        return item.role_limit_day
          ? `领取条件说明：创角${item.role_limit_day}日内，角色累计充值达到${item.condition_threshold}元`
          : `领取条件说明：角色累计充值达到${item.condition_threshold}元`;
      } else if (item.condition_type == 4) {
        return item.role_limit_day
          ? `领取条件说明：创角${item.role_limit_day}日内，角色等级达到${item.condition_threshold}级`
          : `领取条件说明：角色等级达到${item.condition_threshold}级`;
      } else if (item.condition_type == 3) {
        return item.role_limit_day
          ? `领取条件说明：创角${item.role_limit_day}日内，角色单笔充值达到${item.condition_threshold}元`
          : `领取条件说明：角色单笔充值达到${item.condition_threshold}元`;
      } else if (item.condition_type == 6) {
        return item.role_limit_day
          ? `领取条件说明：创角${item.role_limit_day}日内，角色支付宝累计充值达到${item.condition_threshold}元`
          : `领取条件说明：角色支付宝累计充值达到${item.condition_threshold}元`;
      } else if (item.condition_type == 7) {
        return item.role_limit_day
          ? `领取条件说明：创角${item.role_limit_day}日内，角色支付宝单日累计充值达到${item.condition_threshold}元`
          : `领取条件说明：角色支付宝单日累计充值达到${item.condition_threshold}元`;
      } else if (item.condition_type == 8) {
        return `${item.pay_begin_at}后，角色支付宝累计充值达到${item.condition_threshold}元`;
      }
    },
    async openBox() {
      if (!['wxBoxGame', 'boxGame'].includes(this.gameType)) {
        const gameUrl = await generJumpLink();
        gameOpenDownloads({
          gameUrl: this.boxStatus == 1 ? gameUrl.boxGiftUrl : gameUrl.wxBoxGiftUrl,
        });
        this.boxDownLoadShow = true;
      } else {
        if (this.gameType === 'wxBoxGame') {
          skipWXBox2Sdk({
            event: 'boxMoreGift',
            syAppkey: '',
            boxUrl: wxBoxDownloadUrl(),
            routePath: '',
          });
        } else {
          moreGift2sdk({ boxUrl: boxDownloadUrl() });
        }
      }
    },
    showMore() {
      buryReport('BOX_GIFT_RECEIVE');
      this.openBox();
    },
    async showGift(item, submit) {
      if (this.activeTab == 1) {
        buryReport('GIFT_RECEIVE');
        if (item.list_type === 2) {
          this.openBox();
        } else {
          this.popupVisible = true;
        }
      } else {
        buryReportV2('SDK_AUTO_GIFT_CLICK', {
          gift_id: item.gift_common_id,
        });
        this.$store.commit('suspend/CHANGE_STATE', {
          giftRemindShow: true,
          giftCode: item.gift_code,
        });
        this.giftRemindShow = true;
        this.code = item.gift_code;
      }
      if (submit) {
        const appkey = this.$getStorage('appkey');
        const user_id = this.$getStorage('user_id');
        const access_token = this.$getStorage('access_token');
        await giftReceiveApi({
          appkey,
          user_id,
          access_token,
          role_id: this.role.role_id,
          gift_auto_distribute_id: item.gift_auto_distribute_id,
        });
        item.status = 3
        this.$store.dispatch('suspend/getGiftData');
      }
    },
  },
  beforeDestroy() {
    this.clipboard && this.clipboard.destroy();
  },
};
</script>

<style lang="scss" module>
.gift {
  font-size: 15px;
  padding-top: 10px;
  position: relative;
  height: calc(100% - 34px);
  overflow: auto;
  .tabs {
    display: flex;
    margin-left: 12px;
    margin-bottom: 10px;
    > span {
      border: 1px solid #ff5955;
      color: #ff5955;
      margin-right: 20px;
      width: 100px;
      height: 20px;
      text-align: center;
      display: inline-block;
      line-height: 18px;
      font-size: 13px;
      border-radius: 4px;
      &.active {
        color: #ffffff;
        background: #ff5955;
      }
    }
  }
  .getMore {
    position: absolute;
    bottom: 0;
    left: 0;
    background: #ffffff;
    width: 100%;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #ff5b58;
    padding-top: 5px;
    box-shadow: 0px -3px 19px 0px rgba(0, 0, 0, 0.32);
    > img {
      display: inline-block;
      margin-left: 3px;
      width: 12px;
      height: 12px;
    }
  }
  > ul {
    > li {
      width: 322px;
      height: 81px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 0 auto 9px;
      color: #ffffff;
      box-sizing: border-box;
      padding: {
        top: 10px;
        left: 80px;
      }
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      &.showDesc {
        margin-bottom: 20px;
      }
      .info {
        > :nth-child(1) {
          font-size: 16px;
        }
        > :nth-child(2) {
          font-size: 10px;
          margin-top: 8px;
          margin-bottom: 5px;
          width: 155px;
          // background: #000000;
          padding-top: 1px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 2; //行数
          line-clamp: 2;
          -webkit-box-orient: vertical; //盒子中内容竖直排列
        }
        > :nth-child(3) {
          font-size: 10px;
        }
      }
      .oper {
        .btn {
          width: 62px;
          height: 27px;
          border-radius: 22px;
          color: #ffffff;
          text-align: center;
          line-height: 27px;
          margin-top: 9px;
          margin-bottom: 4px;
          &:active {
            opacity: 0.7;
          }
          &.a {
            background: url('#{$cdn-url}/suspend/fuli/6_2.png') no-repeat;
            background-size: 100% 100%;
          }
          &.b {
            background: url('#{$cdn-url}/suspend/fuli/6_4.png') no-repeat;
            background-size: 100% 100%;
          }
          &.c {
            background: url('#{$cdn-url}/suspend/fuli/6_1.png') no-repeat;
            background-size: 100% 100%;
          }
          &.d {
            background: url('#{$cdn-url}/suspend/fuli/6_3.png') no-repeat;
            background-size: 100% 100%;
          }
        }
        .condition {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 16px;
          > span {
            font-size: 10px;
            text-decoration: underline;
            text-align: center;
            color: #1c0000;
            line-height: 22px;
          }
          > img {
            width: 8px;
          }
        }
      }
      .btn {
        flex: none;
        font-size: 12px;
        margin-right: 15px;
        width: 28px;
        height: 28px;
      }
      .desc {
        position: absolute;
        left: 0;
        bottom: -18px;
        width: 100%;
        background: #f5f5f5;
        color: #000000;
        font-size: 9px;
        padding: 5px 5px;
      }
    }
  }
  .showMore {
    font-size: 13px;
    color: #ff5955;
    text-align: right;
    padding-right: 25px;
    text-decoration: underline;
  }
  .empty {
    text-align: center;
    margin-top: 40px;
    color: #7a7979;
    font-size: 10px;
    > img {
      width: 98px;
      display: inline-block;
      margin-bottom: 5px;
    }
    span {
      color: #ff5b58;
    }
    button {
      background: #ff5b58;
      color: #ffffff;
      border: none;
      width: 150px;
      height: 25px;
      border-radius: 14px;
      margin-top: 13px;
      font-size: 9px;
    }
  }
}
</style>
